import Glide from '@glidejs/glide';

import React, { Component, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

/**
 * React Glide Image Slider
 * Glide Image Slider used to an image slider
 * @param props { slides: {src}[] }
 */
export class ReactGlideImageSlider extends Component {

    constructor() {
        super();
        this.id = 'react-glide-image-slider-' + Math.round(Math.random() * 10e6);
    }

    noop() {}
    
    componentDidMount() {
        this.slider = new Glide('#' + this.id);
        
        // Automated height on Carousel change
        //this.slider.on('mount.after', (e) => this.updateTrackHeight(e));
        this.slider.on('run', (e) => this.updateTrackHeight(e));

        // Only mount if we need the slider
        setTimeout(() => this.props.slides.length > 1 ? this.slider.mount() : this.noop());
    }

    updateTrackHeight(event) {
        let maxHeight = 1;
        const glideTrack = document.getElementById(`${this.id}-track`);
        for (let i = 0; i < this.props.slides.length; i++) {
            //const nextSlideIndex = this.slider.index !== undefined ? this.slider.index : (event.direction === '>' ? this.props.slides.length : 0);
            const nextSlide = document.getElementById(`${this.id}-slides`).children.item(i);
            const glideTrack = document.getElementById(`${this.id}-track`);
            if (nextSlide) {
                
                if (nextSlide.offsetHeight > maxHeight) {
                    maxHeight = nextSlide.offsetHeight;
                }
            }
        }
        glideTrack.style.height = `${maxHeight}px`;   
    }

    slideContent(slide) {
        slide.modal_id = 'modal-' + Math.round(Math.random() * 10e6);
        return (
            <div className='glide__slide__content image-variant'>
                <figure>
                    <img src={slide.src} style={{ objectFit: 'scale-down' }}/>
                    <figcaption>{slide.caption}</figcaption>
                </figure>
            </div>
        );
    }
    
    slide(slide, index) {
        return (
            <li className='glide__slide mt-auto mb-auto' key={slide.src}>
                {this.slideContent(slide)}
            </li>
        );
    }
    
    bullets(slides) {
        return (
            <div className="glide__bullets" data-glide-el="controls[nav]">
                {slides.map((slide, i) => (
                    <button className="glide__bullet" key={i} data-glide-dir={'=' + i}>
                        <span className="sr-only">Go to slide {i+1}</span>
                    </button>
                ))}
            </div>
        );
    }

    arrows() {
        return (
            <div className="glide__arrows" data-glide-el="controls">
                <button className="glide__arrow glide__arrow--left" data-glide-dir="<">
                    <i className="chevron"></i>
                    <span className="sr-only">Previous slide</span>
                </button>
                <button className="glide__arrow glide__arrow--right" data-glide-dir=">">
                    <i className="chevron"></i>
                    <span className="sr-only">Next slide</span>
                </button>
            </div>
        );
    }
    
    render() {
        return (
            <div className='react-glide-image-slider glide' id={this.id}>
                <div className='glide__track' data-glide-el='track' id={`${this.id}-track`}>
                    <ul className='glide__slides' id={`${this.id}-slides`}>
                        {this.props.slides.map((slide, index) => this.slide(slide, index))}
                    </ul>
                </div>
                {this.props.slides.length > 1 && this.bullets(this.props.slides)}
                {this.props.slides.length > 1 && this.arrows()}
            </div>
		);
    }
    
}

const reactGlideImageSliderElements = Array.from(
	document.querySelectorAll('[data-react-component="ReactGlideImageSlider"]')
);
if (reactGlideImageSliderElements.length) {
	reactGlideImageSliderElements.forEach(el => {
		if (el.dataset.reactProps) {
            const props = JSON.parse(el.dataset.reactProps);
            //console.log(props);
			ReactDOM.render(<ReactGlideImageSlider slides={props.slides} />, el);
		} else {
			console.log('Missing required props');
		}
	});
}
